function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import classnames from 'classnames';
import { IconEye, IconCheck } from '../Icons';
import FieldContainer from '../FieldContainer';
import handleEvent from '../libs/handleEvent';
import injectStyles from '../jss';
import styles, { DEFAULT_TOP_PADDING, MINIMUM_VERTICAL_PADDING } from './TextField.jss';
export var TextField = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TextField, _React$PureComponent);
  function TextField(props, state) {
    var _this;
    _classCallCheck(this, TextField);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextField).call(this, props, state));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "actionButtonWrapper", void 0);
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "fieldContainer", void 0);
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "label", void 0);
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "input", void 0);
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "assessInputWidth", function () {
      var fieldContainerWidth = _this.fieldContainer.current ? _this.fieldContainer.current.getBoundingClientRect().width : null;
      var actionButtonWidth = _this.actionButtonWrapper.current ? _this.actionButtonWrapper.current.getBoundingClientRect().width : null;
      if (_this.input && typeof fieldContainerWidth === 'number' && typeof actionButtonWidth === 'number') {
        var newWidth = "".concat(fieldContainerWidth - actionButtonWidth - 3, "px");
        _this.input.style.width = newWidth;
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "togglePassword", function () {
      var _this$props = _this.props,
        onHidePassword = _this$props.onHidePassword,
        onShowPassword = _this$props.onShowPassword;
      var isPasswordVisible = _this.state.isPasswordVisible;
      if (onHidePassword && isPasswordVisible) {
        onHidePassword();
      }
      if (onShowPassword && !isPasswordVisible) {
        onShowPassword();
      }
      _this.setState({
        isPasswordVisible: !isPasswordVisible
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onBlur", function (event) {
      var _this$props2 = _this.props,
        name = _this$props2.name,
        onBlur = _this$props2.onBlur;
      handleEvent(name, onBlur, event);
      requestAnimationFrame(function () {
        return _this.calculateInputTopPadding();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (event) {
      var _this$props3 = _this.props,
        name = _this$props3.name,
        onChange = _this$props3.onChange;
      handleEvent(name, onChange, event);
      requestAnimationFrame(function () {
        return _this.calculateInputTopPadding();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onFocus", function (event) {
      var _this$props4 = _this.props,
        name = _this$props4.name,
        onFocus = _this$props4.onFocus;
      handleEvent(name, onFocus, event);
      requestAnimationFrame(function () {
        return _this.calculateInputTopPadding();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleActionButtonClick", function (event) {
      var _this$props5 = _this.props,
        name = _this$props5.name,
        onActionButtonPress = _this$props5.onActionButtonPress,
        value = _this$props5.value;
      if (value) {
        handleEvent(name, onActionButtonPress, value, event);
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "deleteValue", function (event) {
      var _this$props6 = _this.props,
        name = _this$props6.name,
        onClearPress = _this$props6.onClearPress,
        value = _this$props6.value;
      if (onClearPress && _this.input) {
        _this.input.focus();
        handleEvent(name, onClearPress, value, event);
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "createRef", function (element) {
      var inputRef = _this.props.inputRef;
      if (typeof inputRef === 'function') {
        inputRef(element);
      }
      _this.input = element;
    });
    _this.actionButtonWrapper = React.createRef();
    _this.fieldContainer = React.createRef();
    _this.label = React.createRef();
    _this.state = {
      isPasswordVisible: false
    };
    return _this;
  }
  _createClass(TextField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      requestAnimationFrame(function () {
        return _this2.calculateInputTopPadding();
      });
      if (this.props.actionButtonTextDefault) {
        this.assessInputWidth();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props7 = this.props,
        error = _this$props7.error,
        success = _this$props7.success,
        actionButtonTextDefault = _this$props7.actionButtonTextDefault;
      if (actionButtonTextDefault && (prevProps.success !== success || prevProps.error !== error || prevProps.actionButtonTextDefault !== actionButtonTextDefault)) {
        this.assessInputWidth();
      }
    }
    /** The function is to change input's width in response
     *  to the action button's width change, protecting
     *  the elements from overlapping.
     *
     *  @returns {void}
     */
  }, {
    key: "calculateInputTopPadding",
    /**
     * Stretch input height if label with an error has more than 1 line of text
     *
     * @return {void}
     **/
    value: function calculateInputTopPadding() {
      var topPaddingLocked = this.props.topPaddingLocked;
      if (!this.label.current || !this.input || !!topPaddingLocked) {
        return;
      }
      var error = this.props.error;
      this.input.style.paddingTop = error ? "".concat(MINIMUM_VERTICAL_PADDING + this.label.current.offsetHeight, "px") : "".concat(DEFAULT_TOP_PADDING, "px");
    }
  }, {
    key: "renderUnit",
    value: function renderUnit() {
      var _this$props8 = this.props,
        classes = _this$props8.classes,
        unit = _this$props8.unit;
      if (!unit) {
        return null;
      }
      return React.createElement("div", {
        key: "unit",
        className: classes.unit
      }, unit);
    }
  }, {
    key: "renderPasswordToggle",
    value: function renderPasswordToggle() {
      var isPasswordVisible = this.state.isPasswordVisible;
      var _this$props9 = this.props,
        classes = _this$props9.classes,
        error = _this$props9.error,
        success = _this$props9.success;
      var hasIndicator = Boolean(error || success);
      return React.createElement("div", {
        onClick: this.togglePassword,
        className: classnames(classes.passwordToggle, hasIndicator && classes.passwordToggle__withIndicator)
      }, React.createElement(IconEye, {
        className: classnames(classes.passwordToggleIcon, isPasswordVisible && classes.passwordToggleIcon__visible)
      }), hasIndicator && React.createElement("div", {
        className: classnames(classes.iconDivider)
      }));
    }
  }, {
    key: "renderActionButton",
    value: function renderActionButton() {
      var _this$props10 = this.props,
        classes = _this$props10.classes,
        actionButtonTextDefault = _this$props10.actionButtonTextDefault,
        actionButtonTextSuccess = _this$props10.actionButtonTextSuccess,
        success = _this$props10.success,
        error = _this$props10.error,
        disabled = _this$props10.disabled,
        value = _this$props10.value;
      var actionButtonText = success ? actionButtonTextSuccess : actionButtonTextDefault;
      var Tag = success ? 'span' : 'button';
      var isButton = Tag === 'button';
      var buttonAtrributes = isButton ? {
        disabled: disabled,
        type: 'button'
      } : null;
      var isThereButtonContent = actionButtonTextDefault || success && actionButtonTextSuccess || error && value;
      if (!isThereButtonContent) {
        return null;
      }
      return React.createElement("div", {
        className: classnames(classes.actionButtonWrapper, disabled && classes.input__disabled),
        ref: this.actionButtonWrapper
      }, value && error && React.createElement("button", {
        className: classnames(classes.deleteButton, classes.button__destyled),
        onClick: this.deleteValue,
        "aria-label": "Delete value"
      }, "\xD7"), React.createElement(Tag, _extends({
        className: classnames(classes.actionButton, classes.button__destyled, success && classes.actionButton__success)
      }, buttonAtrributes, {
        onClick: this.handleActionButtonClick
      }), success && React.createElement(IconCheck, {
        size: 14
      }), actionButtonText));
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;
      var _this$props11 = this.props,
        actionButtonTextDefault = _this$props11.actionButtonTextDefault,
        autoFocus = _this$props11.autoFocus,
        classes = _this$props11.classes,
        disabled = _this$props11.disabled,
        error = _this$props11.error,
        floatingLabel = _this$props11.floatingLabel,
        hasIndicator = _this$props11.hasIndicator,
        hidePasswordToggle = _this$props11.hidePasswordToggle,
        name = _this$props11.name,
        placeholder = _this$props11.placeholder,
        type = _this$props11.type,
        value = _this$props11.value;
      var isPasswordVisible = this.state.isPasswordVisible;
      var isPassword = type === 'password';
      var hasActionButton = !!actionButtonTextDefault;
      var passwordType = isPasswordVisible ? 'text' : 'password'; // $FlowFixMe

      var inputType = isPassword ? passwordType : type; // $FlowFixMe

      var autocomplete = isPasswordVisible ? 'off' : this.props.autocomplete;
      var shouldHaveIndicator = hasActionButton ? false : hasIndicator;
      return React.createElement(FieldContainer, _extends({}, this.props, {
        hasIndicator: shouldHaveIndicator,
        labelRef: this.label,
        wrapperRef: this.fieldContainer,
        autoHeight: true
      }), React.createElement("div", {
        className: classes.container
      }, React.createElement("input", {
        autoComplete: autocomplete,
        autoFocus: autoFocus,
        className: classnames((_classnames = {}, _defineProperty(_classnames, classes.input, true), _defineProperty(_classnames, classes.input__password, isPassword), _defineProperty(_classnames, classes.input__disabled, disabled), _defineProperty(_classnames, classes.input__hasActionButton, hasActionButton), _defineProperty(_classnames, classes.input__error, error), _classnames)),
        disabled: disabled,
        id: name,
        name: name,
        onBlur: this.onBlur,
        onChange: this.onChange,
        onFocus: this.onFocus,
        placeholder: floatingLabel ? null : placeholder,
        ref: this.createRef,
        type: inputType,
        value: value
      }), hasActionButton && this.renderActionButton(), isPassword && !hidePasswordToggle && this.renderPasswordToggle()), this.renderUnit());
    }
  }]);
  return TextField;
}(React.PureComponent);
_defineProperty(TextField, "styleRoot", 'TextField');
_defineProperty(TextField, "defaultProps", _objectSpread({
  type: 'text'
}, FieldContainer.defaultProps));
export default injectStyles(styles)(TextField);